import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import css from "./styles.less";

class PaxToolBox extends React.Component {
	state = {
		boxVisible: false
	};

	onPaxAction = (currentPax, objKey, objValue, computeFunc) => {
		this.props.onPaxAction(currentPax, objKey, objValue, computeFunc);
	};

	getLabel = () => {
		const {
			pax: { Adults, Children, Infants },
			showInfants,
			titles
		} = this.props;
		let shoulddisplayInfants = showInfants && Infants > 0;
		const numberOfGuests =
			Adults + Children + (shoulddisplayInfants ? 0 : Infants);
		const infantsString = shoulddisplayInfants
			? `${Infants} ${titles.Infants}`
			: "";
		const labelToRender = `${numberOfGuests} ${titles.Guests} ${infantsString}`;
		return labelToRender;
	};

	getLabel_old = () => {
		const { pax, showInfants, showChildren, titles } = this.props;
		let retval = "";
		if (showInfants) {
			retval = `${pax.Adults + pax.Children} ${titles.Adults}, ${pax.Infants} ${
				titles.Infants
			}`;
		} else {
			if (showChildren) {
				retval = `${pax.Adults} ${titles.Adults}, ${pax.Children} ${
					titles.Children
				}`;
			} else retval = `${pax.Adults} ${titles.Adults}`;
		}
		return retval;
	};

	show = () => {
		this.setState({ boxVisible: true });
		document.addEventListener("click", this.hide);
	};

	hide = event => {
		const toolBoxHolderElement = this.toolBoxHolder;
		if (toolBoxHolderElement && toolBoxHolderElement.contains(event.target)) {
			return false;
		}
		this.setState({ boxVisible: false });
		document.removeEventListener("click", this.hide);
	};

	renderPaxAges = paxKey => {
		const { ages, showPaxAges } = this.props;
		if (showPaxAges) {
			return <div className={css.ageDetails}>{`(${ages[paxKey]})`}</div>;
		}
	};

	renderOneLine = (label, objValue, objKey, maxReached, minReached) => {
		const { pax, onPaxAction, titles, ages, showPaxAges } = this.props;
		const { Age } = titles;
		return (
			<div className={css.oneLine}>
				<span className={css.lineLabel}>{objValue + " " + label}</span>
				<div
					className={classnames(css.action, css.incr, maxReached && css.disabled)}
					onClick={() => {
						this.onPaxAction(pax, objKey, objValue, val => ++val);
					}}
				>
					<span className="glyphicon glyphicon-plus" />
				</div>
				<div
					className={classnames(css.action, css.decr, minReached && css.disabled)}
					onClick={() => {
						this.onPaxAction(pax, objKey, objValue, val => --val);
					}}
				>
					<span className="glyphicon glyphicon-minus" />
				</div>
				{this.renderPaxAges(objKey)}
			</div>
		);
	};

	render() {
		const {
			pax,
			numInfants,
			numChildren,
			numAdults,
			maxPax,
			titles,
			showChildren,
			showInfants,
			openDirection
		} = this.props;
		const { Children, Infants, Adults } = titles;

		return (
			<div className={css.paxToolbox}>
				<div className={css.opener} onClick={this.show}>
					<span className={css.openerLabel}>{this.getLabel()}</span>
					<div className={css.arrowHolder}>
						<span
							className={`glyphicon glyphicon-triangle-bottom ${css.openerArrow}`}
						/>
					</div>
				</div>
				<div
					className={classnames(
						css.toolboxHolder,
						this.state.boxVisible && css.show
					)}
					ref={ref => (this.toolBoxHolder = ref)}
				>
					<div className={classnames(
                        css.toolbox,
                        openDirection=='up' && css.upDirection
                    )}>
						{this.renderOneLine(
							Adults,
							pax.Adults,
							"Adults",
							pax.Adults >= numAdults || (pax.Adults + pax.Children >= maxPax && maxPax > 0),
							pax.Adults == 0
						)}
						{showChildren
							? this.renderOneLine(
									Children,
									pax.Children,
									"Children",
									pax.Children >= numChildren || (pax.Adults + pax.Children >= maxPax && maxPax > 0),
									pax.Children == 0
							  )
							: ""}
						{showInfants
							? this.renderOneLine(
									Infants,
									pax.Infants,
									"Infants",
									pax.Infants >= numInfants,
									pax.Infants == 0
							  )
							: ""}
					</div>
				</div>
			</div>
		);
	}
}

PaxToolBox.propTypes = {
	ages: PropTypes.object,
	showPaxAges: PropTypes.bool,
	numAdults: PropTypes.number,
	numChildren: PropTypes.number,
	numInfants: PropTypes.number,
	maxPax: PropTypes.number,
	showChildren: PropTypes.bool,
	showInfants: PropTypes.bool,
	pax: PropTypes.shape({
		Adults: PropTypes.number,
		Children: PropTypes.number,
		Infants: PropTypes.number,
		roomNum: PropTypes.number
	}),
	titles: PropTypes.shape({
		Adults: PropTypes.string,
		Children: PropTypes.string,
		Infants: PropTypes.string
	}),
	isRounded: PropTypes.bool,
	activeRoomNum: PropTypes.number,
	onChangePax: PropTypes.func,
	changeActiveRoomNumber: PropTypes.func,
	onPaxAction: PropTypes.func,
	openDirection: PropTypes.string
};

PaxToolBox.defaultProps = {
	ages: {
		Adults: "12+",
		Children: "2-12",
		Infants: "0-2"
	},
	maxPax: 0,
	showPaxAges: true,
	onPaxAction() {}
};

export default PaxToolBox;



// WEBPACK FOOTER //
// ./src/components/PaxPart/PaxToolBox.js